var render = function render(){var _vm=this,_c=_vm._self._c;return _c('assessment-mode-placeholder',{attrs:{"badge-text":_vm.$t('app.assessment_mode.coming_soon.badge'),"description":_vm.$t('app.assessment_mode.voice.description'),"icon":_vm.mdiMicrophoneOutline,"title":_vm.$t('app.assessment_mode.selection.voice.title')}})
}
var staticRenderFns = []

export { render, staticRenderFns }